<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10">Copyright</h1>
<p class="p6"><span class="t6">Publicado por</span><span class="t6"><br/></span><span class="t6">Dreamspinner Press</span><span class="t6"><br/></span><span class="t6">5032 Capital Cir. SW</span><span class="t6"><br/></span><span class="t6">Ste 2 PMB# 279</span><span class="t6"><br/></span><span class="t6">Tallahassee, FL 32305-7886</span><span class="t6"><br/></span><span class="t6">http://www.dreamspinnerpress.com/</span></p>
<p class="p6"><span class="t6">Esta historia es ficción. Los nombres, personajes, lugares y acontecimientos son producto de la imaginación del autor o usados para la ficción y cualquier similitud con personas vivas o muertas, empresas, hechos o escenarios es mera coincidencia.</span></p>
<p class="p7"><span class="t6">Haciendo Promesas</span></p>
<p class="p7"><span class="t6">Copyright © 2010 by Amy Lane</span></p>
<p class="p6"><span class="t6">Traducido por Rocío Pérez García</span></p>
<p class="p6"><span class="t6">Portada: Paul Richmond  http://www.paulrichmondstudio.com</span></p>
<p class="p6"><span class="t6">La licencia de este libro pertenece exclusivamente al comprador original. Duplicarlo o reproducirlo por cualquier medio es ilegal y una violación de la ley internacional de Derechos de Autor. Este eBook no puede ser prestado legalmente o regalado a otros. Ninguna parte de este eBook puede ser compartida o reproducida sin el permiso expreso de la editorial. Para solicitar el permiso y resolver cualquier duda, contactar con Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886 USA</span><span class="t6"><br/></span><span class="t6">http://www.dreamspinnerpress.com/</span></p>
<p class="p7"><span class="t6">Publicado en los Estados Unidos de América</span><span class="t6"><br/></span><span class="t6">Primera Edición </span></p>
<p class="p6"><span class="t6">Noviembre, 2012</span></p>
<p class="p7"><span class="t6">Edición eBook en Español: 978-1-62380-068-0 </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?989bfa50